import { defineMessages } from "react-intl"

const messages = defineMessages({
  existingImages: {
    id: "search.existing-images",
    defaultMessage: "Search for existing images"
  },
  existingResources: {
    id: "search.existing-resources",
    defaultMessage: "Search by image name, tag, reference ID, etc"
  },
  for: {
    id: "search.for",
    defaultMessage: "for"
  },
  fluidGridView: {
    id: "search-results.fluid-grid-view",
    defaultMessage: "Fluid grid view"
  },
  structuredGridView: {
    id: "search-results.structured-grid-view",
    defaultMessage: "Structured grid view"
  },
  detailsView: {
    id: "search-results.details-view",
    defaultMessage: "Details view"
  },
  listView: {
    id: "search-results.list-view",
    defaultMessage: "List view"
  },
  mapView: {
    id: "search-results.map-view",
    defaultMessage: "Map view"
  },
  searchResultsDisplay: {
    id: "search-results.search-results-display",
    defaultMessage: "Search results display"
  },
  changeResultsCount: {
    id: "search-results.change-results-count",
    defaultMessage: "Show {count} results"
  },
  searchResultSortOrder: {
    id: "search-results.sort-order",
    defaultMessage: "Search result sort order"
  },
  noOfResults: {
    id: "search-results.no-of-results",
    defaultMessage: "No. of results"
  },
  filterStatusOf: {
    id: "filter.status-of",
    defaultMessage: "{first} of {last}"
  },
  filterStatusTo: {
    id: "filter.status-to",
    defaultMessage: "{dateFrom} to {dateTo}"
  },
  filterStatusAll: {
    id: "filter.status-all",
    defaultMessage: "All"
  },
  filterStatusAgesAgo: {
    id: "filter.status-ages-ago",
    defaultMessage: "Ages ago"
  },
  filterStatusToday: {
    id: "filter.status-today",
    defaultMessage: "Today"
  },
  searchResultFilters: {
    id: "filter.search-result-filters",
    defaultMessage: "Search result filters"
  },
  buttonClearDate: {
    id: "button.clear-date",
    defaultMessage: "Clear date"
  },
  buttonToggleAll: {
    id: "button.toggle-all",
    defaultMessage: "Toggle all"
  },
  dateDDMMYY: {
    id: "filter.dd-mm-yyyy",
    defaultMessage: "DD/MM/YYYY"
  },
  dateDDMMYYInclusive: {
    id: "filter.dd-mm-yyyy-inclusive",
    defaultMessage: "DD/MM/YYYY (Inclusive)"
  },
  filterTagPlaceholder: {
    id: "filter.tag-placeholder",
    defaultMessage: "Type to select a tag..."
  },
  filterTextPlaceholder: {
    id: "filter.text-placeholder",
    defaultMessage: "Type to select..."
  },
  narrowSearchResults: {
    id: "search-results.narrow-search-results",
    defaultMessage: "Narrow search results"
  },
  hide: {
    id: "button.hide",
    defaultMessage: "Hide"
  },
  show: {
    id: "button.show",
    defaultMessage: "Filters"
  },
  typeOfContent: {
    id: "search-filters.type-of-content",
    defaultMessage: "Type of content"
  },
  toggleAll: {
    id: "button.toggle-all",
    defaultMessage: "Toggle all"
  },
  licenseStatusText: {
    id: "filter.license-status-text",
    defaultMessage: "License {statusText}"
  },
  from: {
    id: "filter.from",
    defaultMessage: "From"
  },
  to: {
    id: "filter.to",
    defaultMessage: "To"
  },
  taggedWith: {
    id: "filter.tagged-with",
    defaultMessage:
      "Tagged with <small>{tagCount} {tagCount, plural, one {Tag} other {Tags}}</small>"
  },
  taggedWithE: {
    id: "filter.tagged-with-e",
    defaultMessage:
      "Tagged with <small>{tagCount} {tagCount, plural, one {Tag} other {Tags}}</small>"
  },
  clearDate: {
    id: "filter.clear-date",
    defaultMessage: "Clear date"
  },
  loading: {
    id: "message.loading",
    defaultMessage: "Loading..."
  },
  loadingItems: {
    id: "message.loading-from-to",
    defaultMessage: "Load Items {from} to {to}"
  },
  explore: {
    id: "search.explore",
    defaultMessage: "Explore"
  },
  removeQueryTerm: {
    id: "search.remove-query-term",
    defaultMessage: "Remove this term/phrase from current search"
  },
  foundTotal: {
    id: "search.found-total",
    defaultMessage:
      "<span>Found</span> <strong>{total}</strong> {total, plural, one {result} other {results}}"
  },
  foundTotalE: {
    id: "search.found-total-e",
    defaultMessage:
      "<span>Found</span> <strong>{total}</strong> {total, plural, one {result} other {results}}"
  },
  numberSearchResults: {
    id: "search-results.number-search-results",
    defaultMessage: "Found about <strong>{total}</strong> results"
  },
  displayOptions: {
    id: "search-results.display-options",
    defaultMessage: "Display options"
  },
  addTermPhrase: {
    id: "search-type-select",
    defaultMessage: "Add term/phrase to your current search"
  }
})

export default messages



// WEBPACK FOOTER //
// ./webapp/messages/search.js